import { useCallback, useEffect, useState } from 'react';
import { getNotifications, markNotificationRead, markAllNotificationsRead } from '../services/api';

const POLL_MS = 60000;

export const useNotifications = (enabled, refreshKey) => {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  const reload = useCallback(async () => {
    try {
      const data = await getNotifications();
      setItems(data.items || []);
      setUnread(data.unread || 0);
    } catch (error) {
      // silent – bell simply shows stale data
    }
  }, []);

  useEffect(() => {
    if (!enabled) return undefined;
    reload();
    const timer = setInterval(reload, POLL_MS);
    return () => clearInterval(timer);
  }, [enabled, reload, refreshKey]);

  const markRead = useCallback(async (id) => {
    setItems((prev) => prev.map((item) => (item.id === id ? { ...item, is_read: true } : item)));
    setUnread((prev) => Math.max(0, prev - 1));
    try {
      await markNotificationRead(id);
    } catch (error) {
      reload();
    }
  }, [reload]);

  const markAll = useCallback(async () => {
    setItems((prev) => prev.map((item) => ({ ...item, is_read: true })));
    setUnread(0);
    try {
      await markAllNotificationsRead();
    } catch (error) {
      reload();
    }
  }, [reload]);

  return { items, unread, reload, markRead, markAll };
};
